// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.swiper-slide {
    text-align: start;
    background: #fff;
    display: flex;
    justify-content: start;
    align-items: start;
    height: inherit;
}

.swiper-button-prev {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    top: 23px;
    left: 946px;
    background: linear-gradient(56.46deg, #A4EEDC -45.58%, #5BCAB5 19.1%, #6BAAE4 100%);
    z-index: 2;
}

.swiper-button-prev:after {
    display: none;
}

.swiper-button-next {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    top: 23px;
    right: 0;
    background: linear-gradient(56.46deg, #A4EEDC -45.58%, #5BCAB5 19.1%, #6BAAE4 100%);
    z-index: 2;
}

.swiper-button-next:after {
    display: none;
}

.swiper-button-disabled {
    background: none;
}

.swiper-button-disabled {

    border: 1px solid #E9EAEA;
    background: none;
    opacity: 0;
}

.swiper-button-disabled svg path {
    fill: rgba(0, 0, 0, 0.2);
}

.swiper-pagination {
    display: flex;
    justify-content: start;
}

.swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet, .swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet {
    margin: 0 var(--swiper-pagination-bullet-horizontal-gap, 6px);
}

.swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet, .swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet span {
    width: 8px;
    height: 8px;
    background: linear-gradient(56.46deg, #A4EEDC -45.58%, #5BCAB5 19.1%, #6BAAE4 100%);
}
`, "",{"version":3,"sources":["webpack://./src/components/pages/mainPage/Content/Functionality/Slider/styles.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,gBAAgB;IAIhB,aAAa;IAIb,sBAAsB;IAItB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,mFAAmF;IACnF,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,mFAAmF;IACnF,UAAU;AACd;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,yBAAyB;IACzB,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,6DAA6D;AACjE;;AAEA;IACI,UAAU;IACV,WAAW;IACX,mFAAmF;AACvF","sourcesContent":[".swiper-slide {\n    text-align: start;\n    background: #fff;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: -webkit-flex;\n    display: flex;\n    -webkit-box-pack: center;\n    -ms-flex-pack: center;\n    -webkit-justify-content: center;\n    justify-content: start;\n    -webkit-box-align: center;\n    -ms-flex-align: center;\n    -webkit-align-items: center;\n    align-items: start;\n    height: inherit;\n}\n\n.swiper-button-prev {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    top: 23px;\n    left: 946px;\n    background: linear-gradient(56.46deg, #A4EEDC -45.58%, #5BCAB5 19.1%, #6BAAE4 100%);\n    z-index: 2;\n}\n\n.swiper-button-prev:after {\n    display: none;\n}\n\n.swiper-button-next {\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    top: 23px;\n    right: 0;\n    background: linear-gradient(56.46deg, #A4EEDC -45.58%, #5BCAB5 19.1%, #6BAAE4 100%);\n    z-index: 2;\n}\n\n.swiper-button-next:after {\n    display: none;\n}\n\n.swiper-button-disabled {\n    background: none;\n}\n\n.swiper-button-disabled {\n\n    border: 1px solid #E9EAEA;\n    background: none;\n    opacity: 0;\n}\n\n.swiper-button-disabled svg path {\n    fill: rgba(0, 0, 0, 0.2);\n}\n\n.swiper-pagination {\n    display: flex;\n    justify-content: start;\n}\n\n.swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet, .swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet {\n    margin: 0 var(--swiper-pagination-bullet-horizontal-gap, 6px);\n}\n\n.swiper-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet, .swiper-pagination-horizontal.swiper-pagination-bullets .swiper-pagination-bullet span {\n    width: 8px;\n    height: 8px;\n    background: linear-gradient(56.46deg, #A4EEDC -45.58%, #5BCAB5 19.1%, #6BAAE4 100%);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
